<style scoped>
  .TVChartContainer {
    height: 508px;
    border-radius: 5px 5px 0 0;
    overflow: hidden;
    background-color: var(--color-chart);
  }

  .msg {
    font-size: 16px;
    border: 1px solid gray;
    border-radius: 5px;
    margin-bottom: 10px;
  }

  .dragger {
    height: 17.5px;
    cursor: ns-resize;
    position: relative;
    margin-top: -5.5px;
    margin-bottom: -12px;
    user-select: none;
  }

  .dragger img {
    position: relative;
    top: -2px;
  }

  .dragger-active::after {
    content: '';
    position: absolute;
    left: 7px;
    right: 7px;
    top: 8px;
    height: 2px;
    background-color: rgba(74, 144, 217, 0.75);
    box-shadow: 0 0 6px rgba(74, 144, 217, 0.45);
    border-radius: 1px;
    z-index: -1;
  }

  .resizing1 {
    pointer-events: none;
  }

  .ticker {
    border-radius: 0 0 5px 5px;
    border-top: 1px solid var(--color-chart-border);
  }
</style>

<template>
  <div @mouseleave="onDraggerLeave">
      <div v-show="showChart" class="TVChartContainer" :class="{ resizing1 : resizing }" :id="containerId"></div>
      <SymbolTicker class="ticker" mode="grids" />
      <div v-show="showChart" class="dragger" :class="{ 'dragger-active': resizing }" @mousedown="initResize"><img src="@/assets/dragger2.png" draggable="false" /></div>
    <div v-if="$store.state.sys.tradeExchange.ExchId && !showChart" class="msg" style="margin-top: 15px; padding: 10px">
      <span style="font-size: 17px">{{ unavailableMessage }}</span>
    </div>
  </div>
</template>

<script>
import Griddatafeed from '@/services/griddatafeed/'
import { widget } from '@/lib/charting_library'
import { sha256 } from 'js-sha256'
import constants from '@/util/constants'
import Decimal from 'decimal.js'
import Api from '@/util/api'
import Bots from '@/services/bots'
import BotApi from '@/util/botapi'
import Data from '@/util/data'
import $store from '@/store/index'
import Util from '@/util/util'
import MobileDetect from 'mobile-detect'
import SymbolTicker from '@/components/common/SymbolTicker'
import Grids from '@/services/grids'

const pstate = {
  tvWidget: null,
  sells: [],
  arrows: [],
  simArrows: [],
  orders: [],
  ordersData: [],
  minLine: null,
  maxLine: null,
  initialArrowsTimeout: null,
  initialOrdersTimeout: null,
  updateLoopInterval: null
}

export default {
  name: 'GridTV',
  components: {
    SymbolTicker
  },
  data: function () {
    return {
      element: null,
      resizing: false,
      startY: 0,
      startHeight: 0,
      containerId: 'grids_tv_chart_container',
      prevState: '',
      tvReady: false,
      symbolChanging: false
    }
  },
  computed: {
    tradeExchOrSymbolChanged () {
      // eslint-disable-next-line
      let a = this.$store.state.sys.tradeExchange.Id
      // eslint-disable-next-line
      let b = this.eb.symbol

      return Date.now()
    },
    chartSymbol () {
      return constants.exchangeTVIds[this.$store.state.sys.tradeExchange.ExchId] + ':' + this.$store.state.grids.symbol.replace('_', '/')
    },
    eb () {
      return this.$store.state.grids
    },
    exchName () {
      return constants.exchangeTVIds[this.$store.state.sys.tradeExchange.ExchId]
    },
    exchDisplayName () {
      const exchId = this.$store.state.sys.tradeExchange.ExchId
      if (exchId === 'OKX') return 'OKX'
      return constants.exchangeNewIds[exchId]
    },
    unavailableMessage () {
      return this.$text.tr('Grid-боты для {name} недоступны').replace('{name}', this.exchDisplayName)
    },
    showChart () {
      const validEids = ['BYF']
      if (validEids.includes(this.$store.state.sys.tradeExchange.ExchId)) {
        return true
      }
      return false
    }
  },
  watch: {
    'eb.gridsUpdated' () {
      if (!this.tvReady) {
        return
      }
      // this.$nextTick(() => {
      this.updateArrows()
      this.updateOpenOrders()
      // })
    },
    'tradeExchOrSymbolChanged' () {
      if (!this.tvReady || !pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        this.createBotChart()
        return
      }
      this.cleanArrows()
      this.cleanOrders()
      this.symbolChanging = true
      pstate.tvWidget.chart().setSymbol(this.chartSymbol, () => {
        this.symbolChanging = false
        this.updateArrows()
        this.updateOpenOrders()
        this.redrawSimulationArrows()
        this.addGridMinLine()
        this.addGridMaxLine()
      })
    },
    'eb.minPrice' () {
      if (!this.tvReady) {
        return
      }
      this.$nextTick(() => {
        this.addGridMinLine()
        this.addGridMaxLine()
      })
    },
    'eb.maxPrice' () {
      if (!this.tvReady) {
        return
      }
      this.$nextTick(() => {
        this.addGridMinLine()
        this.addGridMaxLine()
      })
    },
    'eb.editMode' () {
      if (!this.tvReady) {
        return
      }
      if (!this.eb.editMode) {
        this.clearLines()
        this.clearSimulationArrows()
        return
      }
      setTimeout(() => {
        this.addGridMinLine()
        this.addGridMaxLine()
      }, 100)
    },
    '$store.state.grids.simTrades' () {
      if (!this.tvReady) {
        return
      }
      this.$nextTick(() => {
        this.redrawSimulationArrows()
      })
    }
  },
  mounted () {
    const savedHeight = localStorage.getItem('capico_app_gridTV_height')
    if (savedHeight) {
      this.$nextTick(() => {
        const el = document.getElementById(this.containerId)
        if (el) {
          el.style.height = savedHeight + 'px'
        }
      })
    }
    if (this.$store.state.sys.email !== '' & this.showChart) {
      this.createBotChart()
    }
  },
  beforeDestroy () {
    if (pstate.initialArrowsTimeout) {
      clearTimeout(pstate.initialArrowsTimeout)
      pstate.initialArrowsTimeout = null
    }
    if (pstate.initialOrdersTimeout) {
      clearTimeout(pstate.initialOrdersTimeout)
      pstate.initialOrdersTimeout = null
    }
    if (pstate.updateLoopInterval) {
      clearInterval(pstate.updateLoopInterval)
      pstate.updateLoopInterval = null
    }
    if (pstate.minLine) pstate.minLine.remove()
    if (pstate.maxLine) pstate.maxLine.remove()
    pstate.sells.forEach(s => s.remove())
    pstate.arrows.forEach(a => a.remove())
    pstate.simArrows.forEach(a => a.remove())
    pstate.orders.forEach(o => o.remove())
    if (pstate.tvWidget) {
      const oldWidget = pstate.tvWidget
      pstate.tvWidget = null
      oldWidget.remove()
    }
  },
  destroyed () {
    pstate.minLine = null
    pstate.maxLine = null
    pstate.sells = []
    pstate.arrows = []
    pstate.simArrows = []
    pstate.orders = []
    pstate.ordersData = []
  },
  methods: {
    sameBounds (oldArr, newArr) {
      if (!oldArr || !newArr || oldArr.length !== newArr.length) {
        return false
      }
      if (oldArr.length === 0) {
        return true
      }
      return JSON.stringify(oldArr[0]) === JSON.stringify(newArr[0]) &&
        JSON.stringify(oldArr[oldArr.length - 1]) === JSON.stringify(newArr[newArr.length - 1])
    },
    sameOrders (oldArr, newArr) {
      if (!oldArr || !newArr || oldArr.length !== newArr.length) {
        return false
      }
      if (oldArr.length === 0) {
        return true
      }
      for (let i = 0; i < oldArr.length; i++) {
        if (JSON.stringify(oldArr[i]) !== JSON.stringify(newArr[i])) {
          return false
        }
      }
      return true
    },
    stopResize (e) {
      window.removeEventListener('mousemove', this.resize, true)
      window.removeEventListener('mouseup', this.stopResize, false)
      this.resizing = false
      if (this.element) {
        localStorage.setItem('capico_app_gridTV_height', parseInt(this.element.style.height))
      }
    },
    resize (e) {
      this.element.style.height = (this.startHeight + (e.clientY - this.startY)) + 'px'
    },
    onDraggerLeave (e) {
      if (this.resizing && e.clientY <= e.currentTarget.getBoundingClientRect().top) {
        this.element.style.height = '0px'
      }
    },
    initResize (e) {
      e.preventDefault()
      this.resizing = true
      this.element = document.getElementById(this.containerId)
      this.startY = e.clientY
      this.startHeight = this.element.offsetHeight
      window.addEventListener('mousemove', this.resize, true)
      window.addEventListener('mouseup', this.stopResize, false)
    },
    addButtons () {
      if (pstate.tvWidget) {
        pstate.tvWidget.headerReady().then(() => {
          const off = this.$text.tr('Bыкл')
          const on = this.$text.tr('Bкл')
          const arrowsSymbol = '⇧'
          const ordersSymbol = '---'
          const arrowsOn = `${off} ${arrowsSymbol}`
          const arrowsOff = `${on} ${arrowsSymbol}`
          const ordersOn = `${off} ${ordersSymbol}`
          const ordersOff = `${on} ${ordersSymbol}`

          const arrowsBtn = pstate.tvWidget.createButton()
          arrowsBtn.style.color = '#8e65e6'
          arrowsBtn.textContent = this.eb.showArrows ? arrowsOn : arrowsOff

          arrowsBtn.addEventListener('click', () => {
            this.eb.showArrows = !this.eb.showArrows
            localStorage.setItem('capico_app_gridTV_showArrows', this.eb.showArrows)
            arrowsBtn.textContent = this.eb.showArrows ? arrowsOn : arrowsOff
            if (this.eb.showArrows) {
              this.updateArrows()
            } else {
              this.cleanArrows()
              pstate.sells = []
            }
          })

          const ordersBtn = pstate.tvWidget.createButton()
          ordersBtn.style.color = '#6b74e7'
          ordersBtn.textContent = this.eb.showOrders ? ordersOn : ordersOff

          ordersBtn.addEventListener('click', () => {
            this.eb.showOrders = !this.eb.showOrders
            localStorage.setItem('capico_app_gridTV_showOrders', this.eb.showOrders)
            ordersBtn.textContent = this.eb.showOrders ? ordersOn : ordersOff
            if (this.eb.showOrders) {
              this.updateOpenOrders()
            } else {
              this.cleanOrders()
            }
          })
        })
      }
    },
    cleanArrows () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      pstate.arrows.forEach(a => {
        if (a) {
          pstate.tvWidget.chart().removeEntity(a, { disableUndo: true })
        }
      })
      pstate.arrows = []
    },
    cleanOrders () {
      pstate.orders.forEach(o => o.remove())
      pstate.orders = []
      pstate.ordersData = []
    },
    clearLines () {
      if (pstate.minLine) {
        pstate.minLine.remove()
        pstate.minLine = null
      }
      if (pstate.maxLine) {
        pstate.maxLine.remove()
        pstate.maxLine = null
      }
    },
    addGridMinLine () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      if (!this.eb.minPrice) {
        return
      }
      if (!this.eb.editMode) {
        return
      }
      if (this.symbolChanging) {
        return
      }

      // if (!this.eb.editMode && this.eb.showOrders) {
      //   return
      // }

      if (pstate.minLine) {
        pstate.minLine.remove()
        pstate.minLine = null
      }

      const pct = new Decimal(this.eb.maxPrice).sub(this.eb.minPrice).mul(100).div(this.eb.maxPrice).toDecimalPlaces(1).abs().toString()
      const title = ' MIN '

      const ref = this
      const color = '#20b2aa'
      pstate.minLine = pstate.tvWidget.chart().createOrderLine()
        .onMove(function () {
          const priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.grids.symbol].PriceDec
          ref.eb.minPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
        })
        .onModify('onModify called', function (text) {
        })
        .setText(title + ' (-' + pct + '%)')
        .setPrice(parseFloat(this.eb.minPrice))
        .setQuantity('')
        .setLineWidth(1)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
    },
    addGridMaxLine () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      if (!this.eb.maxPrice) {
        return
      }
      if (!this.eb.editMode) {
        return
      }
      if (this.symbolChanging) {
        return
      }

      // if (!this.eb.editMode && this.eb.showOrders) {
      //   return
      // }

      if (pstate.maxLine) {
        pstate.maxLine.remove()
        pstate.maxLine = null
      }
      const pct = new Decimal(this.eb.maxPrice).sub(this.eb.minPrice).mul(100).div(this.eb.minPrice).toDecimalPlaces(1).abs().toString()
      const ref = this
      const color = '#f08080'
      const title = ' MAX '
      // if (!this.eb.editBot.Id) {
      //   title = ' NEW SELL '
      // }
      // console.log('adding sell line')
      pstate.maxLine = pstate.tvWidget.chart().createOrderLine()
        .onMove(function () {
          // this.setText('onMove')
          const priceDec = ref.$store.state.data.symbolsfilter[ref.$store.state.grids.symbol].PriceDec
          ref.eb.maxPrice = new Decimal(this.getPrice()).toDP(priceDec, Decimal.ROUND_HALF_UP).toString()
        })
        .onModify('onModify called', function (text) {
        })
        .setText(title + ' (+' + pct + '%)')
        .setPrice(parseFloat(this.eb.maxPrice))
        .setQuantity('')
        .setLineWidth(1)
        .setLineStyle(2)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
    },
    addBuyOrderLine (price) {
      if (!price || !pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      const color = '#20b2aa'
      const line = pstate.tvWidget.chart().createOrderLine()
        .setPrice(parseFloat(price))
        .setText('')
        .setQuantity('')
        .setLineWidth(1)
        .setLineStyle(1)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
      pstate.orders.push(line)
    },
    addSellOrderLine (price) {
      if (!price || !pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      const color = '#f08080'
      const line = pstate.tvWidget.chart().createOrderLine()
        .setPrice(parseFloat(price))
        .setText('')
        .setQuantity('')
        .setLineWidth(1)
        .setLineStyle(1)
        .setLineLength(1)
        .setLineColor(color)
        .setBodyBorderColor(color)
        .setBodyBackgroundColor('#ffffff')
        .setBodyTextColor(color)
        .setQuantityBorderColor(color)
        .setQuantityBackgroundColor(color)
        .setCancelButtonBorderColor(color)
        .setCancelButtonIconColor(color)
      pstate.orders.push(line)
    },
    addSellArrow (order) {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      // console.log('addSellArrow', JSON.stringify(order))
      const shape = 'icon'
      // var shape = 'arrow_down'
      const time1 = new Date(order.sell_executed)
      // console.log('time1', time1.getTime() / 1000)
      const arrow = pstate.tvWidget.chart().createShape(
        {
          time: time1.getTime() / 1000,
          price: parseFloat(order.sell_price)
          // color: 'red'
        }, {
          shape,
          icon: 0xf164,
          // color: '#4caf50',
          // size: 20,
          lock: true,
          zOrder: 'top',
          disableSelection: true,
          disableSave: true,
          disableUndo: true,
          showInObjectsTree: false,
          overrides: {
            color: '#4caf50',
            size: 20
          }
        })
      pstate.arrows.push(arrow)
    },
    addSimulationArrow (trade) {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      // console.log('addSimulationArrow', JSON.stringify(trade))
      const shape = 'icon'
      const time1 = new Date(trade.ts)
      // Use different color/icon for simulation arrows
      const arrow = pstate.tvWidget.chart().createShape(
        {
          time: time1.getTime() / 1000,
          price: parseFloat(trade.price)
        }, {
          shape,
          icon: 0xf005,
          // Different color for simulation arrows (purple)
          color: '#9c27b0',
          size: 18,
          lock: true,
          zOrder: 'top',
          disableSelection: true,
          disableSave: true,
          disableUndo: true,
          showInObjectsTree: false
        })
      pstate.simArrows.push(arrow)
    },
    clearSimulationArrows () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return
      }
      // console.log('clearSimulationArrows')
      pstate.simArrows.forEach(a => {
        pstate.tvWidget.chart().removeEntity(a, { disableUndo: true })
      })
      pstate.simArrows = []
    },
    redrawSimulationArrows () {
      // console.log('redrawSimulationArrows')
      this.clearSimulationArrows()
      for (const trade of this.$store.state.grids.simTrades) {
        this.addSimulationArrow(trade)
      }
    },
    getEarliestLoadedTime () {
      if (!pstate.tvWidget || !pstate.tvWidget._ready || !pstate.tvWidget.chart()) {
        return Promise.resolve(null)
      }
      return pstate.tvWidget.chart()
        .exportData({ includeTime: true, includedStudies: [] })
        .then(res => {
          if (res && res.data && res.data.length && res.data[0] && res.data[0].length) {
            return res.data[0][0]
          }
          return null
        })
        .catch(() => null)
    },
    redrawArrows () {
      // console.log('redrawArrows')
      if (!this.eb.showArrows) {
        this.cleanArrows()
        return
      }
      this.getEarliestLoadedTime().then(minTime => {
        this.cleanArrows()
        if (!this.eb.showArrows) {
          return
        }
        for (const order of pstate.sells) {
          if (!order.sell_executed) {
            continue
          }
          if (minTime) {
            const t = new Date(order.sell_executed).getTime() / 1000
            if (t < minTime) {
              continue
            }
          }
          this.addSellArrow(order)
        }
      })
    },
    updateArrows () {
      if (!this.eb.showArrows) {
        return
      }
      if (this.$router.currentRoute.name !== 'grids') {
        return
      }
      if (this.$store.state.sys.tradeExchange.ExchId !== 'BYF' && this.$store.state.sys.tradeExchange.ExchId !== 'GEF') {
        return
      }
      Grids.GetGridSellsBySymbol().then(response => {
        if (this.sameBounds(pstate.sells, response.data)) {
          return
        }
        pstate.sells = response.data
        this.redrawArrows()
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    updateOpenOrders () {
      if (!this.eb.showOrders) {
        return
      }
      if (this.$router.currentRoute.name !== 'grids') {
        return
      }
      if (this.$store.state.sys.tradeExchange.ExchId !== 'BYF' && this.$store.state.sys.tradeExchange.ExchId !== 'GEF') {
        return
      }
      Grids.GetGridOpenOrdersBySymbol().then(response => {
        if (this.sameOrders(pstate.ordersData, response.data)) {
          return
        }
        pstate.ordersData = response.data
        pstate.orders.forEach(o => o.remove())
        pstate.orders = []
        for (let i = 0; i < response.data.length; i++) {
          const order = response.data[i]
          if (order.status === 'B') {
            // console.log('order.buy_price: ', order.buy_price)
            this.addBuyOrderLine(order.buy_price)
          } else if (order.status === 'S') {
            // console.log('order.sell_price: ', order.sell_price)
            this.addSellOrderLine(order.sell_price)
          }
        }
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    createBotChart () {
      const capicoAppGridsTvInterval = 'capico_app_grids_tv_interval'
      let interval = localStorage.getItem(capicoAppGridsTvInterval)
      if (!interval) {
        interval = '60'
      }
      const userId = sha256(this.$store.state.sys.email)
      const disabledFeatures = ['header_symbol_search', 'timeframes_toolbar', 'header_compare']

      const widgetOptions = {
        debug: false,
        symbol: this.chartSymbol,
        datafeed: Griddatafeed,
        interval,
        container: this.containerId,
        library_path: '/app/charting_library/',
        custom_css_url: '/app/chart.css',
        locale: this.$store.state.sys.lang,
        timezone: Util.getTimezone(),
        disabled_features: disabledFeatures,
        enabled_features: ['side_toolbar_in_fullscreen_mode'],
        charts_storage_url: process.env.VUE_APP_TV_URL,
        charts_storage_api_version: '1.1',
        client_id: 'capico.app',
        user_id: userId,
        fullscreen: false,
        // allow_symbol_change: false,
        autosize: true,
        studies_overrides: {},
        auto_save_delay: 15,
        load_last_chart: true,
        numeric_formatting: { decimal_sign: '.' },
        favorites: {
          intervals: ['1', '60', '1D'],
          chartTypes: ['Candles']
        },
        theme: this.$store.getters.isThemeLight ? 'Light' : 'Dark',
        loading_screen: {
          foregroundColor: Util.getCssVariable('--color-accent'),
          backgroundColor: Util.getCssVariable('--color-chart')
        },
        overrides: {
          // "paneProperties.background": "#404364",
          // "paneProperties.vertGridProperties.color": "#363c4e",
          // "paneProperties.horzGridProperties.color": "#363c4e",
          'symbolWatermarkProperties.transparency': 90,
          // "scalesProperties.textColor": "#AAA",
          // "mainSeriesProperties.candleStyle.wickUpColor": "#336854",
          // "mainSeriesProperties.candleStyle.wickDownColor": "#7f323f",
          'mainSeriesProperties.showCountdown': true,
          // 'mainSeriesProperties.candleStyle.upColor': '#20b2aa',
          // 'mainSeriesProperties.candleStyle.downColor': '#f08080',
          'mainSeriesProperties.candleStyle.drawBorder': false,
          'paneProperties.vertGridProperties.style': 2,
          'paneProperties.horzGridProperties.style': 2

          // #404364
        }
      }
      // eslint-disable-next-line
      const tvWidget = new widget(widgetOptions)

      pstate.tvWidget = tvWidget

      tvWidget.onChartReady(() => {
        this.tvReady = true
        this.addButtons()
        Util.applyChartOverrides(tvWidget, 'bots')

        tvWidget.subscribe('onAutoSaveNeeded', () => {
          // console.log('onAutoSaveNeeded')
          tvWidget.saveChartToServer(null, (err) => console.log(err), { defaultChartName: 'Auto' })
        })

        if (pstate.initialArrowsTimeout) {
          clearTimeout(pstate.initialArrowsTimeout)
        }
        pstate.initialArrowsTimeout = setTimeout(() => {
          pstate.initialArrowsTimeout = null
          this.updateArrows()
        }, 1000)

        if (pstate.initialOrdersTimeout) {
          clearTimeout(pstate.initialOrdersTimeout)
        }
        pstate.initialOrdersTimeout = setTimeout(() => {
          pstate.initialOrdersTimeout = null
          this.updateOpenOrders()
        }, 1000)

        if (pstate.updateLoopInterval) {
          clearInterval(pstate.updateLoopInterval)
        }
        pstate.updateLoopInterval = setInterval(() => {
          this.updateArrows()
          this.updateOpenOrders()
        }, 60000)

        tvWidget.chart().onSymbolChanged().subscribe(null, () => {
          this.$store.state.grids.editGrid = { symbol: tvWidget.chart().symbol().split(':')[1] }
        })

        tvWidget.chart().onIntervalChanged().subscribe(null, (interval, obj) => {
          localStorage.setItem(capicoAppGridsTvInterval, interval)
        })

        tvWidget.chart().onDataLoaded().subscribe(null, () => {
          this.redrawArrows()
          this.redrawSimulationArrows()
        })

        this.addGridMinLine()
        this.addGridMaxLine()
        // this.addBuyOrderLine(this.eb.list[0].min_price)
        // this.addSellOrderLine(this.eb.list[0].max_price)
      })
    }
  }
}
</script>
